import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref, ref } from 'vue';

import {
  NavBar,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { Hero, HeroContainer } from '@/modules/common/components/Hero';
import { BackButton } from '@/modules/common/components/buttons';
import { TemplateHeader } from '@/modules/catalog/components/TemplateHeader';
import { TemplateBenefits } from '@/modules/catalog/components/TemplateBenefits';
import { Allocation } from './components/Allocation';
import { About } from './components/About';
import { ContinueRegistrationModal } from '@/modules/common/components/ContinueRegistrationModal';

import { IPortfolioSheet, EActionButton } from '@/modules/catalog/services/funds';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template',
  setup(__props) {

const createPortfolio = inject('createPortfolio', () => ({}));
const onBack = inject('onBack', () => ({}));

const portfolioSheet = inject('portfolioSheet') as Ref<IPortfolioSheet>;
const isLoading = inject('isLoading') as Ref<boolean>;
const isContinueRegistrationModalOpen = ref(false);

const headerImages = computed(() => {
  return portfolioSheet.value.header.image;
});

const headerData = computed(() => {
  return {
    title: portfolioSheet.value?.header?.title ?? '-',
    description: portfolioSheet.value?.header?.description ?? '-',
    isManagedByWarren: portfolioSheet.value?.header?.isManagedByWarren ?? true
  };
});

function handleButtonClick() {
  const actionButton = portfolioSheet.value?.actionButton;
  
  if (actionButton?.action === EActionButton.ContinueRegistration) {
    isContinueRegistrationModalOpen.value = true;
    return;
  }

  createPortfolio();
}

return { __sfc: true,createPortfolio, onBack, portfolioSheet, isLoading, isContinueRegistrationModalOpen, headerImages, headerData, handleButtonClick, NavBar, ButtonContainer, ButtonPrimary, Hero, HeroContainer, BackButton, TemplateHeader, TemplateBenefits, Allocation, About, ContinueRegistrationModal }
}

})